import axios from 'axios';
import { BASE_URL } from '../config';

/**
 * different axios instances for different use cases, existed to support auth when i was building a resale mktplace
 */

export const axiosPublic = axios.create({ baseURL: BASE_URL, timeout: 10000 });
